import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import randomstring from 'uuid/v4';

import InsertPhoto from '@material-ui/icons/InsertPhoto';
import Timelapse from '@material-ui/icons/Timelapse';

import { bindActionCreators } from 'redux';
import * as actions from '../../../actions/xhef.actions';

import Snackbar from '../../labels/Snackbar';
import src from '../../../images/progress.png';
import { percentage, formatDateTime, timeDiference } from '../../../functions/time';

import { HideIcon } from '../../../images/icons/WrapSvg';

// eslint-disable-next-line
import style from './_styles.css';

function getMachineName(machines, id) {
    const machine = machines.find((f) => f.id === id);
    if (machine) {
        return machine.nombre;
    }
    return '';
}

class Production extends React.Component {
    state = {};

    static getDerivedStateFromProps(props, state) {
        const { xef, tab } = props;
        const data =
            xef && xef.producciones
                ? xef.producciones.filter(
                    (f) =>
                        f.cerrada === null &&
                        (tab === 0 || f.estacion === tab) &&
                        f.produciendo !== null &&
                        !f.finproduccion,
                )
                : [];
        const productos = xef && xef.productos ? xef.productos : [];
        if (data !== state.data) {
            state.data = data;
            state.productos = productos;
            return state;
        }
        return null;
    }

    handleClick = () => {
        this.props.hide();
    };

    handleClickItem = (item) => {
        this.props.handleOpenRun('available', item);
    };

    render() {
        const { data, error, productos } = this.state;
        const { open } = this.props;

        const Item = (item) => {
            const producto = productos.find(f => f.id === item.idProducto);
            const style = {
                backgroundSize:
                    percentage(item.nextrun, this.props.xef_reference_time, item.produciendo) +
                    '% auto',
                backgroundRepeat: 'repeat-y',
                backgroundImage: 'url(' + src + ')',
                backgroundPositionY: 'center',
            };
            return (
                <div
                    key={randomstring()}
                    className="flex_full_row padding_4 boxShadow align_center margin_bottom_12 c_dark_grey_blue hand"
                    style={style}
                    onClick={(event) => this.handleClickItem(item)}
                >
                    {(producto && item && producto.foto) ? (
                        <img
                            src={producto.foto}
                            alt={item.idProducto}
                            style={{ width: 42, height: 42 }}
                            className="borderRadius bg_white margin_right_6"
                        />
                    ) : (
                            <InsertPhoto style={{ fontSize: 42 }} className="c_white margin_right_6" />
                        )}
                    <div className="flex_full_column">
                        <div className="height100 flex_full_row">
                            <span className="flex_auto_row barlowcondensed_light_percentage padding_right_6">
                                {item.cantidad}
                            </span>
                            <span className="flex_full_row barlowcondensed_light_percentage uppercase ">
                                {item.nomProducto}
                            </span>
                        </div>
                        <div className="flex_auto_row">
                            <span className="flex_full_row barlow_regular_small height100 uppercase ">
                                {getMachineName(this.props.machines, item.idMaquina)}
                            </span>
                            {item.preparando ? (
                                <div className="flex_auto_row">
                                    <span className="flex_full_row barlowcondensed_medium elements_from_right padding_right_6  ">
                                        {formatDateTime(item.preparando)}
                                    </span>
                                    <span className="flex_full_row barlowcondensed_small elements_from_right nowrap">
                                        <Timelapse className="margin_right_6" fontSize="small" />
                                        {timeDiference(item.nextrun, this.props.xef_reference_time)}
                                    </span>
                                </div>
                            ) : (
                                    <div className="flex_auto_row">
                                        <span className="flex_full_row barlowcondensed_medium elements_from_right padding_right_6 ">
                                            {formatDateTime(item.creada)}
                                        </span>
                                        <span className="flex_auto_row barlowcondensed_medium elements_from_right nowrap">
                                            <Timelapse className="margin_right_6" fontSize="small" />
                                            {timeDiference(this.props.xef_reference_time, item.creada)}
                                        </span>
                                    </div>
                                )}
                        </div>
                    </div>
                </div>
            );
        };

        return (
            open && (
                <div id="xhef" className="flex_full_column boxShadow bg_ice_blue">
                    <div className="flex_auto_row barlow_semibold c_dark_grey_blue padding_top_6 padding_bottom_12 padding_left_6 padding_right_6 margin_bottom_16">
                        <span className="flex_full_row">
                            <FormattedMessage id="xhef_production" />
                        </span>
                        <HideIcon className="hand c_bluish" onClick={this.handleClick} />
                    </div>
                    <div className="flex_full_column padding_top_6 padding_bottom_12 padding_left_6 padding_right_6 ">
                        {data
                            .sort((a, b) => (a.produciendo > b.produciendo ? 1 : -1))
                            .map((d) => {
                                return <Item key={randomstring()} {...d} />;
                            })}
                    </div>
                    {error && (
                        <Snackbar
                            open={true}
                            variant="error"
                            text={error}
                            nonavbar={true}
                            onClose={this.handleClose}
                        />
                    )}
                </div>
            )
        );
    }
}

function mapStateToProps(state) {
    return {
        info: state.info,
    };
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(Production));



// WEBPACK FOOTER //
// ./src/components/complex/xhef/Production.js